<template>
  <div>
    <canvas id="radar-chart"></canvas>
  </div>
</template>

<script>
import Chart from "chart.js";
export default {
  name: "RadarChart",
  props: ['chartLabel', 'chartUserData', 'standardLabel'],

  data: function () {
    return {
      planetChartData: {
        type: "radar",
        data: {
          labels: this.chartLabel,
          datasets: [
            {
              fill: true,
              backgroundColor: 'rgba(23,229,167,0.24)',
              borderColor:'#17E5A7',


              data: this.chartUserData
            },
          ]
        },
        options: {
          legend: {
            display: false
          },

          responsive: true,
          /*scales: {
            r:[{
              display: true,
              max: 5,
              min: 0,
              ticks: {
                min: 0,
                stepSize: 15
              }
            }],*/

          // }

        }
      }
    }
  },
  mounted() {

    Chart.defaults.global.defaultFontFamily = "IRANSans";
    const ctx = document.getElementById('radar-chart');
    new Chart(ctx, this.planetChartData);
  }
}
</script>

<style scoped>

</style>